import React from 'react';
import Config from '@annunciate/core/dist/utils/config';
import { useChannelQuery } from '@annunciate/query';
import { DiscussionRoot } from './';
export const DiscussionChannelAware = ({ id, type, }) => {
    const { data: channel } = useChannelQuery();
    const channelSettings = channel && channel?.channel?.settings?.comments;
    const isDiscussionChannelReady = channelSettings && channelSettings?.isEnabled;
    return (React.createElement(React.Fragment, null, isDiscussionChannelReady && id && Config.COMMENTS_HOST && (React.createElement(DiscussionRoot, { id: `${type}/${id}`, endpoint: Config.COMMENTS_HOST, depth: Infinity }))));
};
//# sourceMappingURL=DiscussionChannelAware.js.map